<template>
  <div class="container-list">
    <div class="common-page common-head">
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
            </div> -->
    </div>
    <div class="flex">
      <!-- <unitList @select="getUnit"></unitList> -->
      <!-- <unitList  
         v-show="$store.state.userInfo.role==0"
       
          @select="getUnit"
        @getFirst="getOne"></unitList> -->
      <div class="flex1">
        <div
          class="common-page common-tool-bar"
          style="justify-content: space-between"
        ></div>
        <div class="common-page common-list">
          <el-table :data="list" class="">
              <el-table-column prop="pointName" label="巡查点名称" align="center"> </el-table-column>
              <el-table-column prop="pointAddr" align="center" label="巡查点位置"> </el-table-column>
              <!-- <el-table-column
              prop="c_point_states"
              align="c_point_error"
              label="是否异常"
            >
              isNormal
              <template slot-scope="scope">{{
                $map.isNormal[scope.row.c_point_error]
              }}</template>
            </el-table-column> -->
              <el-table-column prop="pointStatisticsNum" align="center" label="上报次数"> </el-table-column>
               <el-table-column prop="pointErrorDesc" label="巡查结果描述" align="center"> </el-table-column>

              <el-table-column prop="commitName" align="center" label="上报人姓名"> </el-table-column>
              <el-table-column prop="commitTime" align="center" label="最近上报时间"></el-table-column>
<!-- 
            <el-table-column prop="pointNum" label="巡查点编号" align="center"> </el-table-column>
              <el-table-column prop="pointAddr" align="center" label="巡查点位置"> </el-table-column>
			  <el-table-column prop="commitName" align="center" label="上报人姓名"> </el-table-column>
							<el-table-column prop="correctiveMeasures" label="巡查结果描述" align="center"> </el-table-column>
						  <el-table-column prop="commitTime" align="center" label="上次检查时间"> </el-table-column>
              <el-table-column prop="pointStates" align="center" label="状态">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    :type="scope.row.pointStates == 5 ? 'success' : scope.row.pointStates == 4 ? 'danger' : scope.row.pointStates == 3 ? 'primary' : scope.row.pointStates == 2 ?'warning': 'info'"
                  >
                    {{ $map.checkstates[scope.row.pointStates] }}
                  </el-button>
                </template>
              </el-table-column> -->
            	  <el-table-column label="操作" align="center" width="200px" fixed="right">
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      path: '/wenlv/inspectionDangerDetail',
                      query: { id: scope.row.id },
                    }"
                    v-if="scope.row.pointStates == 2 || scope.row.pointStates == 3"
                    
                  >
                  <!--  -->
                    <el-button size="mini" type="primary" v-hasPermi="['relic:relicInspectionRecords:updateStatus']">审核</el-button>
                  </router-link>
                  <router-link
                    :to="{
                      path: '/wenlv/inspectionDangerDetail',
                      query: { id: scope.row.id, view: 1 },
                    }"
                    
                  >
                  <!-- v-hasPermi="['safe:record:edit']" -->
                    <el-button size="mini" type="primary" v-hasPermi="['relic:relicInspectionRecords:selectInfoById']">详情</el-button>
                  </router-link>
                </template>
              </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="pageChange"
          :page-size="10"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="resetSearch" size="small">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {getCompanyList,switchCompany} from '../../api/company'
import unitList from "@/components/unitList";
export default {
  data() {
    return {
      list: [],
      cpNum: '',
      params: {
       commitName: '',
					pointStates: '',
					pointAddr: '',
					companyNum: this.cpNum || this.$store.state.user.company.cCompanyNum||this.$route.query.id,
					pointError: '',
					startTime: '',
					pointNum: '',
					// pointNum: this.$route.query.id || '',
					commitTime: '',
					endTime: '',
					pageSize: 10,
					pageNum: 1,
      },
      outPutForm: {},

      total: 0,
      showDia: false,
      searchForm: this.$getForm("rescuredSearch"),
      editData: {},
      remoteFuncs: {
        _this: this,
        getNumber(resolve) {
          var _this = this._this;
          _this.$post("/xuncha/selectxcnum").then((res) => {
            console.log(res);
            resolve(res.data);
          });
        },
        getPerson(resolve) {
          var _this = this._this;
          _this.$post("/xuncha/selectxcuser").then((res) => {
            console.log(res);
            resolve(res.data);
          });
        },
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "/safe/rescureddetail") {
        vm.getList();
      }
      //因为当钩子执行前，组件实例还没被创建
      // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
      console.log(vm); //当前组件的实例
    });
  },
  watch: {
    cpNum(v) {
      if (v) {
        this.params.companyNum = this.cpNum;
        this.params.pageNum = 1;
        this.getList();
      }
    },
  },
  created() {
    this.getList();
  },
  components: {
    unitList,
  },
  methods: {
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    //导出
    outPut() {
      var obj = { ...this.params, ...this.outPutForm };
      var {
        c_point_name,
        c_point_addr,
        c_point_error,
        c_company_num,
        start_time,
        c_point_number,
        c_commit_name,
        end_time,
      } = obj;
      console.log(obj);
      var url = `${this.$config.apiUrl}/xuncha/yinhuandownload?c_company_num=${c_company_num}&c_point_name=${c_point_name}&c_point_addr=${c_point_addr}&c_point_error=${c_point_error}&c_point_number=${c_point_number}&c_commit_name=${c_commit_name}&start_time=${start_time}&end_time=${end_time}`;
      window.location = url;
    },

    changeStatus(id, status) {
      switchCompany({ id, status })
        .then((res) => {
          this.getList();
        })
        .catch((err) => {});
    },
    getList() {
      this.$get("/relic/relicInspectionRecords/getHiddenDangerList", this.params).then((res) => {
        console.log(res,3333);
					// this.list = res.data.list;
					// this.total = res.data.count;
					 this.list = res.rows;
        			this.total = res.total;
				});
      // this.params.c_point_states = Number(this.params.c_point_states) || "";
      // this.$post("/hidden/hiddenlist", this.params).then((res) => {
      //   this.list = res.data.list;
      //   this.total = res.data.count;
      // });
    },
    pageChange(val) {
      this.params.pageNum = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          console.log(this.params);
          this.params.pageNum = 1;

          this.getList();
          this.showDia = false;
          this.outPutForm = this.params;

          // this.$refs.searchForm.reset();
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      console.log(this.params);
      this.params.c_company_num =
        this.cpNum || this.$store.state.user.company.cCompanyNum;
      this.getList();
      this.outPutForm = {};
    },
  },
};
</script>

<style scoped></style>
